
<div class="modal fade {{culture}} {{brand}}" id="rules" tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                 <h5 [innerHTML]="'pop-rules-header' | translate"></h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body"  [innerHTML]="'pop-rules-body-aeg' | translate">

            </div>
        </div>
    </div>
</div>

<div class="modal fade {{culture}} {{brand}}" id="policy" tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 [innerHTML]="'pop-policy-header' | translate"></h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body" [innerHTML]="'pop-policy-body' | translate">
                Policy
            </div>
        </div>
    </div>
</div>


<div class="modal fade {{culture}} {{brand}}" id="faq" tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 [innerHTML]="'pop-faq-header' | translate"></h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <!---->
            <div class="modal-body"  [innerHTML]="'pop-faq-body-aeg' | translate" >
               <!-- <h5>
                   Lorem ipsum dolor sit amet consectetur adipisicing elit.
               </h5>
               <p>
                Quo sit nam consequuntur rerum vel excepturi aliquid suscipit hic nobis nostrum! Aperiam numquam omnis incidunt culpa vero eius reiciendis harum perferendis.
               </p>

               <h5>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
            </h5>
            <p>
             Quo sit nam consequuntur rerum vel excepturi aliquid suscipit hic nobis nostrum! Aperiam numquam omnis incidunt culpa vero eius reiciendis harum perferendis.
            </p>

            <h5>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
            </h5>
            <p>
             Quo sit nam consequuntur rerum vel excepturi aliquid suscipit hic nobis nostrum! Aperiam numquam omnis incidunt culpa vero eius reiciendis harum perferendis.
            </p>

            <h5>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
            </h5>
            <p>
             Quo sit nam consequuntur rerum vel excepturi aliquid suscipit hic nobis nostrum! Aperiam numquam omnis incidunt culpa vero eius reiciendis harum perferendis.
            </p> -->
            </div>
        </div>
    </div>
</div>


<div class="modal fade {{culture}} {{brand}}" id="products" tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 [innerHTML]="'pop-products-header' | translate"></h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <!-- -->
            <div class="modal-body" [innerHTML]="'pop-products-body-aeg' | translate" >
               <!-- <div class="intro">
                   <h3>
                       Products
                   </h3>
                   <p>
                       Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus perspiciatis placeat beatae. 
                   </p>
                  
               </div>
               <table class="table">
                    
                <tbody>
                  <tr>
                   
                    <td>Prod 1</td>
                    <td>120€</td>
                   
                  </tr>
                  <tr>
                    <td>Prod 2</td>
                    <td>140€</td>
                  </tr>
                  <tr>
                    <td>Prod 3</td>
                    <td>130€</td>
                  </tr>
                </tbody>
              </table> -->
            </div>
        </div>
    </div>
</div>